module.exports = __webpack_public_path__ + "static/media/card_bg.dfe189db.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/card_bg.png
// module id = 1744
// module chunks = 0 1